import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';

import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2';
import { getLocaleDateTimeFormat, getLocaleDateFormat } from '@angular/common';
import { HandleError } from '../../shared/HandleError';
declare var $: any;

@Component({
  selector: 'app-uploads',
  templateUrl: './uploads.component.html',
  styleUrls: ['./uploads.component.css']
})
export class UploadsComponent implements OnInit {
  su:any= {};
  SainikDetails: any;
  isSainikExist: boolean;
  DocumentTypes: any;
  title = "Uploads";
  data: any;
  fileToUpload: File = null;
  s: any = {};
  u: any = {};
  formInvalid: boolean = false;
  itemQuantity = [];

  DuploadId:any;


 imageUrl: string = "assets/images/image-default.png";
  mode: string = "save";
  UserName: string;
  RoleName: string;
  finalizeddata: any;
  Formdiable: boolean = false;

  constructor(private service: RegistrationService,private handleError:HandleError) {
  }

  ngOnInit() {
    this.GetAllDocumentTypes();
    this.itemQuantity = Array(10).fill(0).map((x,i)=>i+1);
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.SR_ServiceNo=this.UserName;
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)
    this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo)
    this.GetfinalizeForUploads(this.UserName);
  }
  }
  GetfinalizeForUploads(SR_ServiceNo)
  {
    debugger;
    this.data = this.service.getfinalizeForUploads(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.finalizeddata=response;
        if(this.finalizeddata=='F')
       {
        this.Formdiable=true;
       }
      },
      (error) => {
        console.log(error);
      });
  }
  GetSainikDetailsFromRegistration(SR_ServiceNo:any){
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForUploads(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        debugger;
        this.isSainikExist = true;
        this.s.SR_Id=response.sainikRegistrationBasicDetails.SR_Id;
        this.s=response.sainikRegistrationBasicDetails;
        for (let i = 0; i < this.Uploads.length; i++) {
          //this.ng.IsSelected=false;
          this.s.SDU_File=this.Uploads[i].SDU_File;
         // su.value.SDU_DT_Id_FK=this.Uploads[i].SDU_DT_Id_FK;
        //su.value.SDU_Category=this.Uploads[i].SDU_Category;
          //su.value.SDU_Category="AAdhar";//ref hardcoded
        }

        //this.SDU_File = data.SDU_File;
        //this.SDU_File=response.SainikUploads
        if(response.SainikUploads.length!=0){
         this.Uploads=response.SainikUploads;
         this.mode = "update";
        }
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
        //swal('Warning!', 'Sainik does not exist.', 'warning');
        swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }
  // FileInput(file: FileList) {
  //   let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf)$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       this.imageUrl = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.service.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //       }, (error) => {
  //         let i:any=document.getElementById('SDU_File');
  //         i.value="";
  //         if (error.status == 400) {
  //           this.imageUrl = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('SDU_File');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension jpg, jpeg or png", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload image file less than 2mb", 'warning');
  //   }
  // }


  CheckDocumenttype(documenttypename){
    debugger;
    for (let i = 0; i < this.Uploads.length; i++) {
      if (this.Uploads[i].SDU_Category == documenttypename) {
        if(this.Uploads[i].SDU_Category == 'Photo' ||this.Uploads[i].SDU_Category == 'WidowPhoto'|| 
        this.Uploads[i].SDU_Category == 'FingerPrint' ||this.Uploads[i].SDU_Category == 'Signature')
       swal('Already Exist');
      }
    }

    // for (let i = 0; i < this.itemQuantity.length; i++) {
    //   for (let j = 0; i < this.Uploads.length; i++) {
    //   if (this.itemQuantity[i].PageNo == this.Uploads[j].PageNo) {
    //    alert("remove from ");
    //    this.itemQuantity.splice(i, 1);
    //   }
    // }
    // }
    // for (let i = 0; i < this.Uploads.length; i++) {
    //   if (this.Uploads[i].SDU_Category == documenttypename) {
    //     for (let j = 0; i < this.itemQuantity.length; j++) {
    //       if(this.Uploads[i].PageNo==this.itemQuantity[j]){
    //         this.itemQuantity.splice(j, 1);
    //       }
    //     }
    //   }
    // }
  }


  //public quantities: Array<number> = [];
// getQuantity() {
  //  for (let i = 1; i <= 100; i++) {
  //    this.quantities.push(i)
   // }
  //}

 // export class UploadsComponent {
 //   itemQuantity = []; // instantiates the object to hold array of numbers
    
 //   public ngOnInit() {
   //     this.itemQuantity = Array(5).fill(0).map((x,i)=>i+1); // fills array with 5 incremental entries starting from 1 (hence the "i+1"). To start at zero remove the "+1"
    //}
   // }

  GetAllDocumentTypes() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllDocumentTypes();
    this.data.subscribe(
      (response) => {
        this.DocumentTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  getImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('SDU_File');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  Uploads = [];
  SDU_Category_errormessage = "";
  SDU_File_errormessage = "";

  AddUploads(u) {
  debugger;
  if (u.SDU_File==undefined || u.SDU_File==null && u.SDU_Category==undefined ||u.SDU_Category==null) {
  //  let filename=(u.SDU_File)[10];
  swal("Please select the file to upload");
   //if (this.checkAllFamilyValidation(fd)) {
      
   }
  else
   {
    let temp = {
      categoryname: u.SDU_Category.DT_Name,
      SDU_Id:u.SDU_Id,
      //categoryname: u.DT_Name,
      //SDU_DT_Id_FK: u.SDU_Category.DT_Id,
      SDU_Category :u.SDU_Category.DT_Name,
      SDU_DT_Id_FK:this.GetDocumentTypeId(u.SDU_Category.DT_Name), 
      SDU_File:this.getCancelPDFUrl(),
      PageNo:u.PageNo,
      serviceNo:this.s.SR_ServiceNo,
     // SDU_Date:getLocaleDateFormat
    }
    this.Uploads.push(temp);
  //  for (let i = 0; i < this.Uploads.length; i++) {
  //       if (this.Uploads[i].SDU_Category == documenttypename) {
  //         for (let j = 0; i < this.itemQuantity.length; j++) {
  //           if(this.Uploads[i].PageNo==this.itemQuantity[j]){
  //             this.itemQuantity.splice(j, 1);
  //           }
  //         }
  //       }
  //     }
    this.closeModalDialog();
    this.u = {};
   }
  }


  GetDocumentTypeId(categoryname) {
    debugger;
    for (let i = 0; i < this.DocumentTypes.length; i++) {
      if (this.DocumentTypes[i].DT_Name == categoryname) {
        let SDU_DT_Id_FK = this.DocumentTypes[i].DT_Id;
        return SDU_DT_Id_FK;
      }
    }
  }

  ClearForm(){
    this.s.SR_ServiceNo="";
    this.s.SR_ServiceType="";
    this.s.SR_Category="";
    this.s.SR_Name="";
    this.s.SR_SurName="";
    this.Uploads = [];
   }


  // RemoveUploads(i) {
  //   this.Uploads.splice(i, 1);
  // }

 RemoveUploads(i)
  {  
    debugger;

    var DuploadId = this.Uploads[i].SDU_Id;
    if(DuploadId==undefined || DuploadId==0)
    {
      this.Uploads.splice(i, 1);
    }
  //wrkng
  //   for (let j = 0; j < this.Uploads.length; j++) {
  //     if (j == i) {
  //       let DuploadId = this.Uploads[j].SDU_Id;
  //       return DuploadId;
  //    }
  // }
   // this.dependentId=this.x.SD_Id;
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.service.deleteUpload(DuploadId).subscribe(
          (data:any) => {
            swal('','Upload Deleted!','success');
            this.Uploads.splice(i, 1);
            document.getElementById('loader-spinner').style.display="none";
            //this.GetAllDistricts(this.itemsPerPage, 1);
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.handleError.ErrorHandler(error);
          });
      }
    })     
  } 
  
// RemoveUploads(i)
//   {  
//     debugger;
//     swal({
//       title: "Are you sure?",
//       text: "Your will not be able to recover this details!",
//       type: "warning",
//       showCancelButton: true,
//       confirmButtonClass: "btn-danger",
//       confirmButtonText: "Yes, delete it!",
//       closeOnConfirm: false
//   },
//   function () {
//     for (let j = 0; j < this.Uploads.length; j++) {
//       if (j == i) {
//         let DuploadId = this.Uploads[j].SDU_Id;
//         return DuploadId;
//      }
//   }
//     document.getElementById('loader-spinner').style.display = "block";
//     this.service.deleteUpload(this.DuploadId).subscribe(
//           (data:any) => {
//             swal('','District Deleted!','success');
//             //this.GetAllDistricts(this.itemsPerPage, 1);
//           },(error) => {
//             document.getElementById('loader-spinner').style.display="none";
//             this.handleError.ErrorHandler(error);
//           });
//       }
   
//   } 

 
  
  closeModalDialog(){
    $("#uploadpopup").modal('hide'); 
   }

//reference img upload
  //FingerPrintFileInput(file: FileList) {
  //  console.log(file);
 //   this.fileToUpload = file.item(0);
 //   var reader = new FileReader();
  //  reader.onload = (event: any) => {
  //    this.fingerprintimageUrl = event.target.result;
  //  }
 //   reader.readAsDataURL(this.fileToUpload);
  //  const data = new FormData();
  //  data.append("UploadedImage", file.item(0));
 //   let x = this.service.uploadImage(data);
 //   x.subscribe(
   //   (response) => {
    //    console.log(response);
   //   }, (error) => {
 //       console.log(error);
  //    });
 // }
//reference
 FileInput(file: FileList) {
   debugger;
  //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.JPG|.JPEG|.PNG)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      // this.FeasibilityPDFUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.service.uploadImage(data);
    x.subscribe(
      (response) => {
        // console.log(response);
        // this.app.APP_PA_PhotoErrorMessage="";

      }, (error) => {
        let i: any = document.getElementById('SDU_File');
        i.value = "";
        if (error.status == 400) {
          // this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('SDU_File');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getCancelPDFUrl() {
  let imagename = null;
  try {
    imagename = document.getElementById('SDU_File');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

/*onSubmit(form: NgForm,APP_No:any,Amount:any,APP_Status:any) {
debugger;
  if (!form.invalid) {
  document.getElementById('loader-spinner').style.display = "block";
  form.value.CR_Doc_File = this.getCancelPDFUrl();
  this.service.CreateCancelRequest(form.value,APP_No,Amount,APP_Status)
    .subscribe(
      (data) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Saved Successfully!','success');
        //this.router.navigate(['/home/appstatus']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //this.errorHandler.HandlerError(error);
      });
    }else
    document.getElementById('loader-spinner').style.display = "none";
   // this.formSubmitted = true;
}*/
//ref till here



  SaveSainikUploads(serviceNo,sainikId,su: NgForm){
    debugger;
   // if (br.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
          // su.value.SR_FingerPrint = this.getImage();
      su.value.SDU_File=this.getImage();
      for (let i = 0; i < this.Uploads.length; i++) {
        //this.ng.IsSelected=false;
        su.value.SDU_File=this.Uploads[i].SDU_File;
        su.value.SDU_DT_Id_FK=this.Uploads[i].SDU_DT_Id_FK;
       su.value.SDU_Category=this.Uploads[i].SDU_Category;
       su.value.PageNo=this.Uploads[i].PageNo;
        //su.value.SDU_Category="AAdhar";//ref hardcoded
      }
      //su.value.SDU_DT_Id_FK=this.u.SDU_DT_Id_FK;
      //this.data = this.service.saveSainikUploads(sainikId,su.value);
      this.data = this.service.saveSainikUploads(serviceNo,sainikId,this.Uploads);
      this.data.subscribe(
        (response) => {
          //console.log(su)
          //su.reset();
          //su.resetForm();
          //f.form.markAsPristine();
          // f.form.markAsUntouched();
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          this.s.SR_ServiceNo="";
          this.s.SR_ServiceType="";
          this.s.SR_Category="";
          this.s.SR_Name="";
          this.s.SR_SurName="";
          this.Uploads = [];
          }
          this.formInvalid = false;
          swal('Success!', 'Sainik details saved successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    }
   // else {
   //   swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
  //    this.formInvalid = true;
   // }
  //}

  GetSainikBasicDetails(SR_ServiceNo:any){
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForUploads(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        debugger;
        this.isSainikExist = true;
        this.s.SR_Id=response.sainikRegistrationBasicDetails.SR_Id;
        this.s=response.sainikRegistrationBasicDetails;
        for (let i = 0; i < this.Uploads.length; i++) {
          //this.ng.IsSelected=false;
          this.s.SDU_File=this.Uploads[i].SDU_File;
         // su.value.SDU_DT_Id_FK=this.Uploads[i].SDU_DT_Id_FK;
        //su.value.SDU_Category=this.Uploads[i].SDU_Category;
          //su.value.SDU_Category="AAdhar";//ref hardcoded
        }

        //this.SDU_File = data.SDU_File;
        //this.SDU_File=response.SainikUploads
        if(response.SainikUploads.length!=0){
         this.Uploads=response.SainikUploads;
         this.mode = "update";
        }
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400){
         if(this.RoleName=="Super Admin"){
          swal('Warning!', 'Sainik does not exist, Please fill the details', 'warning');
          }
          else{
            swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
           }
          } 
        //swal('Warning!', 'Sainik does not exist.', 'warning');
        //swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }


  Cancel(){
    this.u.SDU_Category="";
    this.u.PageNo="";
    this.u.SDU_File="";
  }

  
}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/uploads/uploads.component.ts